import React from "react";
import { ShieldCheck } from "lucide-react";
import VerticalPage from "@/pages/VerticalPage";

const TYPE_OPTIONS = [
  { value: "life",   label: "Life" },
  { value: "health", label: "Health" },
  { value: "motor",  label: "Motor" },
  { value: "home",   label: "Home" },
  { value: "travel", label: "Travel" },
  { value: "other",  label: "Other" },
];

const FORMAT_INR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return null;
  try { return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n)); }
  catch { return `₹${Number(n).toLocaleString("en-IN")}`; }
};

export default function Insurance() {
  return (
    <VerticalPage
      title="Insurance"
      subtitle="Policies, premiums, renewals"
      endpoint="/insurance"
      singularType="insurance"
      icon={ShieldCheck}
      colorClass="text-sky-500 bg-sky-500/12"
      emptySubtitle="Add every policy — health, life, motor — and get gentle renewal reminders."
      typeField={{ name: "ins_type", label: "Category", options: TYPE_OPTIONS }}
      sections={[
        {
          title: "Policy",
          fields: [
            { name: "title",         label: "Policy name",  type: "text", placeholder: "e.g. HDFC Ergo Health Suraksha", required: true, colSpan: 2 },
            { name: "provider",      label: "Insurer",      type: "text", placeholder: "e.g. HDFC Ergo" },
            { name: "policy_number", label: "Policy number",type: "text", placeholder: "e.g. HE-12345" },
            { name: "premium",       label: "Premium (₹)",  type: "number", placeholder: "25000" },
            { name: "sum_insured",   label: "Sum insured (₹)", type: "number", placeholder: "1000000" },
            { name: "nominee",       label: "Nominee",      type: "text", placeholder: "Nominee name" },
          ],
        },
        {
          title: "Dates",
          fields: [
            { name: "start_date",        label: "Start date",    type: "date" },
            { name: "renewal_date",      label: "Renewal date",  type: "date" },
            { name: "next_payment_date", label: "Next payment",  type: "date", colSpan: 2 },
          ],
        },
        {
          title: "More",
          fields: [
            { name: "notes", label: "Notes", type: "textarea", placeholder: "Coverage details, exclusions, etc.", colSpan: 2 },
          ],
        },
      ]}
      formatMeta={(it) => {
        const typeLbl = TYPE_OPTIONS.find((o) => o.value === it.ins_type)?.label;
        const line1 = [typeLbl, it.provider].filter(Boolean).join(" · ");
        const line2Parts = [];
        if (it.policy_number) line2Parts.push(`# ${it.policy_number}`);
        if (it.renewal_date) line2Parts.push(`Renew ${it.renewal_date}`);
        if (it.sum_insured) line2Parts.push(`Cover ${FORMAT_INR(it.sum_insured)}`);
        return { line1, line2: line2Parts.join(" · ") };
      }}
    />
  );
}
